import { NavLink } from 'react-router-dom'

import { cn } from '@/shared/lib/cn'

export interface TabItem {
  to: string
  label: string
  /** Contador a la derecha del label (tareas abiertas, contactos…). */
  count?: number
}

export interface TabsNavProps {
  items: readonly TabItem[]
  label: string
  className?: string
}

export function TabsNav({ items, label, className }: TabsNavProps) {
  return (
    <nav aria-label={label} className={cn('flex flex-wrap items-center gap-1', className)}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end
          className={({ isActive }) =>
            cn(
              'inline-flex h-6 items-center gap-1.5 rounded-[var(--radius-control)] px-2 text-xs',
              'transition-colors duration-[var(--motion-fast)]',
              isActive
                ? 'bg-surface-2 text-text-1'
                : 'text-text-2 hover:bg-surface-2 hover:text-text-1',
            )
          }
        >
          {item.label}
          {item.count !== undefined ? (
            <span className="num text-2xs text-text-3">{item.count}</span>
          ) : null}
        </NavLink>
      ))}
    </nav>
  )
}
